export interface Product {
  id: string
  name: string
  price: number
  colorways: string[]
  sizes: string[]
  image: string
  description: string
}

export const products: Product[] = [
  {
    id: 'vsc-logo-heavyweight-tee',
    name: 'VSC Logo Heavyweight Tee',
    price: 42,
    colorways: ['Black', 'White', 'Washed Grey'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    image:
      'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?auto=format&fit=crop&q=80&w=800',
    description:
      'The foundation of any streetwear rotation. Cut from ultra-heavyweight 100% cotton, this tee features a relaxed, boxy fit that drapes perfectly. Finished with our signature high-density VSC logo hit on the chest.',
  },
  {
    id: 'vsc-varsity-bomber-jacket',
    name: 'VSC Varsity Bomber Jacket',
    price: 148,
    colorways: ['Black/Gold', 'Navy/White'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    image:
      'https://images.unsplash.com/photo-1551028719-00167b16eac5?auto=format&fit=crop&q=80&w=800',
    description:
      'A modern take on a classic silhouette. Our Varsity Bomber features a premium wool-blend body with contrasting sleeves. Detailed with custom VSC chenille patches and ribbed trims for an authentic vintage feel.',
  },
  {
    id: 'vsc-cargo-joggers',
    name: 'VSC Cargo Joggers',
    price: 88,
    colorways: ['Olive', 'Black', 'Cream'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    image:
      'https://images.unsplash.com/photo-1517438476312-10d79c077509?auto=format&fit=crop&q=80&w=800',
    description:
      'Utility meets comfort. These cargo joggers are constructed from durable ripstop cotton with a slight stretch. Featuring articulated knees, multiple utility pockets, and adjustable bungee cuffs for a customizable fit.',
  },
  {
    id: 'vsc-signature-hoodie',
    name: 'VSC Signature Hoodie',
    price: 95,
    colorways: ['Charcoal', 'Burgundy', 'Forest Green'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    image:
      'https://images.unsplash.com/photo-1556821840-3a63f95609a7?auto=format&fit=crop&q=80&w=800',
    description:
      'Your new daily driver. Crafted from 450gsm French terry, this hoodie offers unparalleled warmth and structure. Features an oversized hood, dropped shoulders, and a subtle embroidered logo on the wrist.',
  },
  {
    id: 'vsc-snapback-cap',
    name: 'VSC Snapback Cap',
    price: 38,
    colorways: ['Black', 'White', 'Olive'],
    sizes: ['OSFA'],
    image:
      'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?auto=format&fit=crop&q=80&w=800',
    description:
      'The finishing touch. A structured 6-panel snapback with a flat brim and raised 3D embroidery of the VSC lettermark. Adjustable snap closure ensures a perfect fit for all.',
  },
  {
    id: 'vsc-oversized-coach-jacket',
    name: 'VSC Oversized Coach Jacket',
    price: 118,
    colorways: ['Black', 'Stone'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    image:
      'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?auto=format&fit=crop&q=80&w=800',
    description:
      'Weather-resistant and street-ready. This coach jacket features a water-repellent nylon shell, breathable mesh lining, and an oversized fit for easy layering. Finished with tonal snap buttons and a bold back graphic.',
  },
  {
    id: 'vsc-ribbed-long-sleeve',
    name: 'VSC Ribbed Long Sleeve',
    price: 55,
    colorways: ['Tan', 'Black', 'Slate Blue'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    image:
      'https://images.unsplash.com/photo-1618354691373-d851c5c3a990?auto=format&fit=crop&q=80&w=800',
    description:
      'An elevated essential. Made from a premium ribbed cotton blend that hugs the body while providing exceptional stretch. Perfect as a base layer or worn on its own.',
  },
  {
    id: 'vsc-logo-sweatpants',
    name: 'VSC Logo Sweatpants',
    price: 78,
    colorways: ['Black', 'Heather Grey'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    image:
      'https://images.unsplash.com/photo-1605518216938-7c31b7b14ad0?auto=format&fit=crop&q=80&w=800',
    description:
      'Lounge in luxury. These heavyweight sweatpants feature a relaxed fit, elasticated cuffs, and deep side pockets. The VSC logo is subtly printed down the left leg.',
  },
]
